import { Component, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { SharedService } from '@cfp/core';
import { Badge } from '@cfp/ui';
import { TagsService } from 'csr-asset-app';
import { catchError, combineLatest, map, of, startWith, switchMap } from 'rxjs';

@Component({
  selector: 'cfp-building-tags',
  templateUrl: './building-tags.html',
  styleUrls: ['./building-tags.scss'],
  imports: [Badge]
})
export class BuildingTags {
  public readonly buildingId = input.required<number>();

  protected readonly tagsService = inject(TagsService);
  protected readonly sharedService = inject(SharedService);

  private reloadTrigger = this.sharedService.reloadComponentObservable.pipe(
    map(() => new Date().getTime()) // Force a new value on each emission
  );

  protected readonly tags = toSignal(
    combineLatest([toObservable(this.buildingId), this.reloadTrigger.pipe(startWith(null))]).pipe(
      switchMap(([buildingId]) => {
        if (!buildingId) {
          return of(undefined);
        }
        return this.tagsService
          .v2BuildingsBuildingIdTagsGet(buildingId)
          .pipe(map((tags) => tags.filter((tag) => tag.enabled)));
      }),
      catchError(() => of(undefined))
    )
  );
}
